import { FAVORITES_COUNT_KEY } from '../constants.js';

export const SET_READY_FLAG = (state) => {
  state.isReady = true;
};

export const TOGGLE_LOADING_FLAG = (state, val) => {
  state.isLoading = val;
};

export const TOGGLE_LOADING_NEW_PAGE_FLAG = (state, val) => {
  state.isLoadingNext = val;
};

export const SET_NEW_LINK = (state, link) => {
  state.next = link;
};

export const SET_LAST_SIGNALS = (state, data) => {
  state.lastSignals = data;
};

export const SET_LOADING_LAST_SIGNALS = (state, val) => {
  state.isLoadingLastSignals = val;
};

export const SET_READY_LAST_SIGNALS = (state, val) => {
  state.readyLastSignals = val;
};

export const CHANGE_ID_EDIT_SIGNAL = (state, id) => {
  state.idEditSignal = id || null;
};

export const TOGGLE_SIGNAL_SEND_LOADING_FLAG = (state, val) => {
  state.isSignalSendLoading = val;
};

export const UPDATE_DRAFT_FORM = (state, data) => {
  state.draftForm = data;
};

export const SAVE_FAVORITES_COUNT_TO_STORAGE = (state) => {
  const count = state.map.filter(
    (id) => state.data[id]?.reactions?.bookmarked?.is_mine === true
  ).length;

  try {
    localStorage.setItem(FAVORITES_COUNT_KEY, String(count));
  } catch (err) {
    console.warn("Не удалось сохранить избранные в LS:", err);
  }
};